/* Pepper + Vetiver - HGTV: Shop the Kitchen
   AJAX add to cart for the landing page section.
   Bound on document capture with stopImmediatePropagation so the Rebuy Smart Cart
   form handler (which does a full-page redirect to /?viewcart=true) never runs.
   Rebuy still detects the /cart/add.js request and opens its drawer. */
(function () {
  if (window.__stkCartBound) return;
  window.__stkCartBound = true;

  function addUrl() {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root + 'cart/add.js';
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target && event.target.closest ? event.target.closest('[data-stk-form]') : null;
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (form.dataset.stkBusy === '1') return;

      var input = form.querySelector('input[name="id"]');
      if (!input || !input.value) return;

      var button = form.querySelector('button[type="submit"]');
      var label = button ? button.querySelector('span') : null;
      var original = label ? label.textContent : '';
      var done = form.getAttribute('data-stk-added') || 'Added';

      form.dataset.stkBusy = '1';
      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      }

      function release() {
        form.dataset.stkBusy = '';
        if (button) {
          button.removeAttribute('aria-busy');
          button.disabled = false;
        }
      }

      function fallback() {
        release();
        window.location.href = form.getAttribute('data-stk-url') || '/cart';
      }

      fetch(addUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: input.value, quantity: 1 }] })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || (result.data && result.data.status)) {
            fallback();
            return;
          }
          release();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          if (label) {
            label.textContent = done;
            setTimeout(function () {
              label.textContent = original;
            }, 2600);
          }
        })
        .catch(fallback);
    },
    true
  );
})();
